var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.015,
    height: 19.829,
    viewBox: "0 0 18.015 19.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bag_icon",
    "data-name": "Bag icon",
    transform: "translate(-14.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(14.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M32.7,19.336l-1.482-13.8a.452.452,0,0,0-.444-.4H28.037V4.3a4.3,4.3,0,0,0-8.594,0v.84H16.629a.452.452,0,0,0-.444.4L14.7,19.336a.443.443,0,0,0,.1.346.4.4,0,0,0,.321.148H32.285a.4.4,0,0,0,.321-.148A.443.443,0,0,0,32.7,19.336ZM27.593,7.631a.4.4,0,1,1-.4.4A.39.39,0,0,1,27.593,7.631ZM20.333,4.3a3.408,3.408,0,0,1,6.816,0v.84H20.333Zm-.444,3.334a.4.4,0,1,1-.4.4A.39.39,0,0,1,19.888,7.631ZM15.641,18.916,17.024,6h2.42v.815a1.259,1.259,0,1,0,.84,0V6H27.1v.815a1.259,1.259,0,1,0,.84,0V6h2.519L31.84,18.916Z",
    transform: "translate(-14.696)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.3d044a1d803a201d6d3b559a500fb7c0.svg";
export { ForwardRef as ReactComponent };